import { render, staticRenderFns } from "./PredefinedComment.vue?vue&type=template&id=38ccca50&"
import script from "./PredefinedComment.vue?vue&type=script&lang=js&"
export * from "./PredefinedComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports